import { render, staticRenderFns } from "./FeedAssetArea.vue?vue&type=template&id=1070f28c&"
import script from "./FeedAssetArea.vue?vue&type=script&lang=js&"
export * from "./FeedAssetArea.vue?vue&type=script&lang=js&"
import style0 from "./FeedAssetArea.vue?vue&type=style&index=0&id=1070f28c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports